import { asJsonObjectValueOrNull } from "@/types/json"

/**
 * Validate that a string is a valid JSON object (not array, not primitive).
 * Returns null if valid or empty, otherwise an error message.
 */
export function validateJsonObject(value: string): string | null {
  if (value.trim() === "") {
    return null
  }

  try {
    const parsed: unknown = JSON.parse(value)
    if (!asJsonObjectValueOrNull(parsed)) {
      return "Must be a JSON object"
    }
    return null
  } catch {
    return "Invalid JSON format"
  }
}

/**
 * Format a JSON string or object for pretty-printed display.
 * Returns the original string if parsing fails, or empty string for falsy input.
 */
export function formatJsonString(
  jsonString: string | object | null | undefined,
): string {
  if (!jsonString) {
    return ""
  }
  if (typeof jsonString === "object") {
    return JSON.stringify(jsonString, null, 2)
  }
  if (jsonString.trim() === "") {
    return ""
  }
  try {
    const parsed: unknown = JSON.parse(jsonString)
    return JSON.stringify(parsed, null, 2)
  } catch {
    return jsonString
  }
}
